<template>
  <div
    class="overflow-hidden border-y border-n-weak divide-y divide-n-weak bg-n-surface-1"
  >
    <slot />
  </div>
</template>
